let tabs = document.querySelectorAll('.tabs ul li');
let tabsWrap = document.querySelectorAll('.tab_wrap');

tabs[0].querySelector('span').classList.add('active');
tabsWrap[0].style.display = "block";

tabs.forEach(function(tab, tabIndex) {

    tab.addEventListener('click', function() {

        tabs.forEach(function(tab) {
            tab.querySelector('span').classList.remove('active');
        })

        tab.querySelector('span').classList.add('active');

        tabsWrap.forEach(function(content, contentIndex) {
            if(contentIndex === tabIndex) {
                content.style.display = "block";
            } else {
                content.style.display = "none";
            }
        })
    })
});